/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WorkspaceJoinRequestStatus {
  REQUESTED = 'requested',
  REJECTED = 'rejected',
  CANCELLED = 'cancelled',
}
